import * as THREE from 'three'
import assetsLoader from '@/plugins/assets-loader'

function generateModel() {
  const gradientMap = assetsLoader.get('threeTone').subject

  const model = assetsLoader.get('sakura').subject.scene.clone()
  model.traverse((child) => {
    if (child.name.includes('petales')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xffaadf,
        gradientMap,
      })
    }

    if (child.name.includes('pistil')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xffaadf,
        gradientMap,
      })
    }

    if (child.name.includes('bouton')) {
      child.material = new THREE.MeshToonMaterial({
        color: 0xf24b57,
        gradientMap,
      })
    }

    if (child.name === 'outline') {
      child.material = new THREE.MeshBasicMaterial({
        color: 0x000000,
      })
    }
  })

  return model
}

export default class Sakura extends THREE.Object3D {
  constructor() {
    super()
    const model = generateModel()

    this.add(model)
  }
}
